document.addEventListener("DOMContentLoaded", () => {
    const cookieBanner = document.querySelector(".cookie-banner");
    const closeBtn = document.querySelector("#close-cookie-banner");

    if (!cookieBanner) return;

    function setCookie() {
        const date = new Date();
        date.setDate(date.getDate() + 7);
        const expiryDate = date.toUTCString();
        document.cookie = `cookieAccepted=true; expires=${expiryDate}; path=/`;
    }

    function checkCookie() {
        return document.cookie
            .split(";")
            .some((item) => item.trim().startsWith("cookieAccepted=true"));
    }

    if (!checkCookie()) {
        cookieBanner.classList.add("active");
    }

    closeBtn.addEventListener("click", () => {
        cookieBanner.classList.remove("active");
        setCookie();
    });
});
